import React from "react";
/* eslint-disable max-len */
export default {
  companyWebsite: "jdwireartstudio.com",
  policy: [
    {
      isBold: false,
      text:
        "This privacy policy has been compiled to better serve those who are concerned with how their 'Personally Identifiable Information' (PII) is being used online. PII, as described in US privacy law and information security, is information that can be used on its own or with other information to identify, contact, or locate a single person, or to identify an individual in context. Please read our privacy policy carefully to get a clear understanding of how we collect, use, protect or otherwise handle your Personally Identifiable Information in accordance with our website."
    },
    {
      isBold: true,
      text:
        "What personal information do we collect from the people that visit our blog, website or app?"
    },
    {
      isBold: false,
      text:
        "When ordering or registering on our site, as appropriate, you may be asked to enter your name, email address, phone number or other details to help you with your experience."
    },
    { isBold: true, text: "When do we collect information?" },
    {
      isBold: false,
      text:
        "We collect information from you when you fill out a form or enter information on our site."
    },
    { isBold: true, text: "How do we use your information?" },
    {
      isBold: false,
      text:
        "We may use the information we collect from you when you register, make a purchase, sign up for our newsletter, respond to a survey or marketing communication, surf the website, or use certain other site features in the following ways:"
    },
    {
      isBold: false,
      text:
        "To follow up with them after correspondence (live chat, email or phone inquiries)"
    },
    { isBold: true, text: "How do we protect your information?" },
    {
      isBold: false,
      text:
        "We do not use vulnerability scanning and/or scanning to PCI standards."
    },
    {
      isBold: false,
      text:
        "We only provide articles and information. We never ask for credit card numbers."
    },
    { isBold: false, text: "We do not use Malware Scanning." },
    {
      isBold: false,
      text:
        "Your personal information is contained behind secured networks and is only accessible by a limited number of persons who have special access rights to such systems, and are required to keep the information confidential. In addition, all sensitive/credit information you supply is encrypted via Secure Socket Layer (SSL) technology."
    },
    {
      isBold: false,
      text:
        "We implement a variety of security measures when a user enters, submits, or accesses their information to maintain the safety of your personal information."
    },
    {
      isBold: false,
      text:
        "All transactions are processed through a gateway provider and are not stored or processed on our servers."
    },
    { isBold: true, text: "Do we use 'cookies'?" },
    {
      isBold: false,
      text:
        "Yes. Cookies are small files that a site or its service provider transfers to your computer's hard drive through your Web browser (if you allow) that enables the site's or service provider's systems to recognize your browser and capture and remember certain information. For instance, we use cookies to help us remember and process the items in your shopping cart. They are also used to help us understand your preferences based on previous or current site activity, which enables us to provide you with improved services. We also use cookies to help us compile aggregate data about site traffic and site interaction so that we can offer better site experiences and tools in the future."
    },
    { isBold: true, text: "We use cookies to:" },
    {
      isBold: false,
      text:
        "Compile aggregate data about site traffic and site interactions in order to offer better site experiences and tools in the future. We may also use trusted third-party services that track this information on our behalf."
    },
    {
      isBold: false,
      text:
        "You can choose to have your computer warn you each time a cookie is being sent, or you can choose to turn off all cookies. You do this through your browser settings. Since browser is a little different, look at your browser's Help Menu to learn the correct way to modify your cookies."
    },
    {
      isBold: false,
      text: "If you turn cookies off, it won't affect the user's experience."
    },
    { isBold: true, text: "Third-party disclosure" },
    {
      isBold: false,
      text:
        "We do not sell, trade, or otherwise transfer to outside parties your Personally Identifiable Information."
    },
    { isBold: true, text: "Third-party links" },
    {
      isBold: false,
      text:
        "We do not include or offer third-party products or services on our website."
    },
    { isBold: true, text: "Google" },
    {
      isBold: false,
      text: `Google's advertising requirements can be summed up by Google's Advertising Principles. They are put in place to provide a positive experience for users.`
    },
    {
      isBold: false,
      text: (
        <a href="https://support.google.com/adwordspolicy/answer/1316548?hl=en">
          Google Support AdWords Policy
        </a>
      )
    },
    {
      isBold: false,
      text: "We use Google AdSense Advertising on our website."
    },
    {
      isBold: false,
      text:
        "Google, as a third-party vendor, uses cookies to serve ads on our site. Google's use of the DART cookie enables it to serve ads to our users based on previous visits to our site and other sites on the Internet. Users may opt-out of the use of the DART cookie by visiting the Google Ad and Content Network privacy policy."
    },
    { isBold: true, text: "We have implemented the following:" },
    { isBold: false, text: "Demographics and Interests Reporting" },
    {
      isBold: false,
      text:
        "We, along with third-party vendors such as Google use first-party cookies (such as the Google Analytics cookies) and third-party cookies (such as the DoubleClick cookie) or other third-party identifiers together to compile data regarding user interactions with ad impressions and other ad service functions as they relate to our website."
    },
    { isBold: true, text: "Opting out:" },
    {
      isBold: false,
      text:
        "Users can set preferences for how Google advertises to you using the Google Ad Settings page. Alternatively, you can opt out by visiting the Network Advertising Initiative Opt Out page or by using the Google Analytics Opt Out Browser add on."
    },
    { isBold: true, text: "California Online Privacy Protection Act" },
    {
      isBold: false,
      text:
        "CalOPPA is the first state law in the nation to require commercial websites and online services to post a privacy policy. The law's reach stretches well beyond California to require any person or company in the United States (and conceivably the world) that operates websites collecting Personally Identifiable Information from California consumers to post a conspicuous privacy policy on its website stating exactly the information being collected and those individuals or companies with whom it is being shared."
    },
    { isBold: true, text: "According to CalOPPA, we agree to the following:" },
    { isBold: false, text: "Users can visit our site anonymously." },
    {
      isBold: false,
      text:
        "Once this privacy policy is created, we will add a link to it on our home page."
    },
    {
      isBold: false,
      text:
        "Our Privacy Policy link includes the word 'Privacy' and can easily be found on the page specified above."
    },
    {
      isBold: false,
      text:
        "You will be notified of any Privacy Policy changes on our Privacy Policy Page"
    },
    {
      isBold: false,
      text: "Can change your personal information by emailing us"
    },
    { isBold: true, text: "How does our site handle Do Not Track signals?" },
    {
      isBold: false,
      text:
        "We honor Do Not Track signals and Do Not Track, plant cookies, or use advertising when a Do Not Track (DNT) browser mechanism is in place."
    },
    {
      isBold: true,
      text: "Does our site allow third-party behavioral tracking?"
    },
    {
      isBold: false,
      text:
        "It's also important to note that we do not allow third-party behavioral tracking"
    },
    { isBold: true, text: "COPPA (Children Online Privacy Protection Act)" },
    {
      isBold: false,
      text:
        "When it comes to the collection of personal information from children under the age of 13 years old, the Children's Online Privacy Protection Act (COPPA) puts parents in control. The Federal Trade Commission, United States' consumer protection agency, enforces the COPPA Rule, which spells out what operators of websites and online services must do to protect children's privacy and safety online."
    },
    {
      isBold: false,
      text:
        "We do not specifically market to children under the age of 13 years old."
    },
    {
      isBold: false,
      text:
        "Do we let third-parties, including ad networks or plug-ins collect PII from children under 13?"
    },
    { isBold: true, text: "Fair Information Practices" },
    {
      isBold: false,
      text:
        "The Fair Information Practices Principles form the backbone of privacy law in the United States and the concepts they include have played a significant role in the development of data protection laws around the globe. Understanding the Fair Information Practice Principles and how they should be implemented is critical to comply with the various privacy laws that protect personal information."
    },
    {
      isBold: true,
      text:
        "In order to be in line with Fair Information Practices we will take the following responsive action, should a data breach occur:"
    },
    {
      isBold: false,
      text: "We will notify you via email within 7 business days"
    },
    {
      isBold: false,
      text:
        "We also agree to the Individual Redress Principle which requires that individuals have the right to legally pursue enforceable rights against data collectors and processors who fail to adhere to the law. This principle requires not only that individuals have enforceable rights against data users, but also that individuals have recourse to courts or government agencies to investigate and/or prosecute non-compliance by data processors."
    },
    { isBold: true, text: "CAN SPAM Act" },
    {
      isBold: false,
      text:
        "The CAN-SPAM Act is a law that sets the rules for commercial email, establishes requirements for commercial messages, gives recipients the right to have emails stopped from being sent to them, and spells out tough penalties for violations."
    },
    { isBold: true, text: "We collect your email address in order to:" },
    {
      isBold: false,
      text:
        "Send information, respond to inquiries, and/or other requests or questions"
    },
    {
      isBold: true,
      text: "To be in accordance with CANSPAM, we agree to the following:"
    },
    {
      isBold: false,
      text: "Not use false or misleading subjects or email addresses."
    },
    {
      isBold: false,
      text: "Identify the message as an advertisement in some reasonable way."
    },
    {
      isBold: false,
      text: "Include the physical address of our business or site headquarters."
    },
    {
      isBold: false,
      text:
        "Monitor third-party email marketing services for compliance, if one is used."
    },
    { isBold: false, text: "Honor opt-out/unsubscribe requests quickly." },
    {
      isBold: false,
      text:
        "Allow users to unsubscribe by using the link at the bottom of each email."
    },
    {
      isBold: true,
      text:
        "If at any time you would like to unsubscribe from receiving future emails, you can follow the instructions at the bottom of each email and we will promptly remove you from ALL correspondence."
    },
    { isBold: true, text: "Contacting Us:" },
    {
      isBold: false,
      text:
        "We welcome any comments or suggestions you may have regarding this privacy policy.  You may contact us using the information below."
    },
    { isBold: true, text: "aaron.sisler@eandbsolutions.com" }
  ]
};
